import { useState } from 'react';
import apiService from '../../axios/apiService';

export const useGetCaseFile = () => {
    const [data, setData] = useState(undefined);
    const [loading, setLoading] = useState(false);
    const getCaseFile = async (caseId, objectKey, fileName) => {
        // Fetch case
        setLoading(true);
        try {
            const response = await apiService.getCaseFile(caseId, objectKey, fileName);
            response && setData(response); // update data state
            return response;
        } catch (error) {
            console.log("Error: ", error);
        } finally {
            setLoading(false);
        }
    }

    return {
        data,
        loading,
        getCaseFile,
    }
}